import { render, staticRenderFns } from "./MasterGroupForm.vue?vue&type=template&id=20a1dcd5"
import script from "./MasterGroupForm.vue?vue&type=script&lang=js"
export * from "./MasterGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports